import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import { FooterButton } from '../../core/components';
import { useDispatch } from 'react-redux';
import { addMachine, editMachine } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';

const initData = {
  id: 0,
  userId: '',
  assetNumber: '',
  cellNumber: '',
  brand: '',
  modelNumber: '',
  tonnage: '',
  shotsize: '',
  tieBarDistanceH: '',
  tieBarDistanceV: '',
  moldheightMin: '',
  moldheightMax: '',
  serialNumber: '',
  numberofCores: '',
  numberofValveGates: '',
  numberofAirBlows: '',
  changed: '',
  isDeleted: '',
  lane: '',
  orientation: '0',
};

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];

const editKeys = ['changed', 'isDeleted'];

const EditMachine = ({ data, onChanges, onCloseModal }) => {
  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    onChanges({ ...formData, [fieldName]: value });
  };

  const orientationOptions = [
    { value: 0, label: 'Select Orientation' },
    { value: 1, label: 'Horizontal' },
    { value: 2, label: 'Vertical' },
  ];

  const dispatch = useDispatch();
  const isEditMode = Boolean(data?.id);

  const handleClose = () => {
    onCloseModal();
  };

  const valid = () => {
    // Removed mandatory validation - all fields are now optional
    return true;
  };

  const onSave = () => {
    if (valid()) {
      const payload = {
        ...formData,
        userId: localStorage.getItem('UserId'),
      };
      if (isEditMode) {
        dispatch(editMachine(payload));
      } else {
        dispatch(addMachine(payload));
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Asset Number
            </label>
            <div className="input-groupicon calender-input">
              <input
                name="assetNumber"
                type="text"
                className="form-control"
                value={formData.assetNumber}
                onChange={e => updateFormField('assetNumber', e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Cell Number
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.cellNumber}
                onChange={e => updateFormField('cellNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Brand
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.brand}
                onChange={e => updateFormField('brand', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Model Number
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.modelNumber}
                onChange={e => updateFormField('modelNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tonnage
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.tonnage}
                onChange={e => updateFormField('tonnage', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Shot Size (oz)
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.shotsize}
                onChange={e => updateFormField('shotsize', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tie Bar Distance (Horizontal)
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.tieBarDistanceH}
                onChange={e => updateFormField('tieBarDistanceH', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tie Bar Distance (Vertical)
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.tieBarDistanceV}
                onChange={e => updateFormField('tieBarDistanceV', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Mold Height Minimum
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.moldheightMin}
                onChange={e => updateFormField('moldheightMin', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Mold Height Maximum
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.moldheightMax}
                onChange={e => updateFormField('moldheightMax', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Serial Number
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.serialNumber}
                onChange={e => updateFormField('serialNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Cores
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.numberofCores}
                onChange={e => updateFormField('numberofCores', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Valve Gates
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.numberofValveGates}
                onChange={e => updateFormField('numberofValveGates', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Air Blows
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.numberofAirBlows}
                onChange={e => updateFormField('numberofAirBlows', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Lane
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData.lane}
                onChange={e => updateFormField('lane', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Orientation
            </label>
            <select
              value={formData.orientation}
              onChange={e => updateFormField('orientation', e.target.value)}
              className="form-control"
             
            >
              {orientationOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Machine"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    </>
  );
};

EditMachine.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.machines),
  onChanges: PropTypes.func,
};

export default EditMachine;
